<template>
  <section class="features">
    <div class="container">
      <h2 style="color: black;">深耕行业 · 高效招人</h2>
      <Row class="responsive-row" :gutter="0">
        <Col :span="12" v-for="(feature,index) in features" :key="feature.title" class="feature-col">
          <div class="feature-card-content">
            <div style="display: flex;flex-direction: column">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
              <a @click="login()">一键登录 →</a>
            </div>
            <img :src="feature.image" :class="[index === 0 ? 'feature-icon-first' : 'feature-icon']">
          </div>
        </Col>
      </Row>
      <CenterDialog
        :visible.sync="show"
        type="image"
        width="240px"
        title="请长按识别前往小程序继续操作"
        :image="imageQrcode"
        :showActions="false"
      />
    </div>
  </section>
</template>

<script>
import store from "@/store";
import router from "@/router";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";

export default {
  name: 'FeaturesSection',
  components: {CenterDialog},
  data() {
    return {
      show: false,
      imageQrcode: require('@/assets/img/qrcode_shangjia.jpg'),
      features: [
        {
          title: '多种渠道 · 快速曝光',
          description: '覆盖多平台投放渠道，职位更快推荐',
          image: require('@/assets/img/air.gif'),
        },
        {
          title: '极速便捷 · 发布职位',
          description: '流程精简，3分钟即可发布职位',
          image: require('@/assets/img/eletric.gif'),
        },
        {
          title: '快速联系 · 实时沟通',
          description: '报名后即时通知，点击一键联系',
          image: require('@/assets/img/phone.gif'),
        },
        {
          title: '多端协同 · 数据同步',
          description: '多端打通，随时随地高效管理',
          image: require('@/assets/img/hezuo.gif'),
        }
      ]
    }
  },
  methods: {
    login() {
      if(this.util.isInMobileWx()){
        this.show = true;
        return
      }
      if (store.state.token){
        router.push('/hometoc')
      } else {
        router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.features {
  background: #F6F7FB;
  padding: 60px 0 0 0;
  text-align: center;
}

h2 {
  font-size: 32px;
  margin-bottom: 40px;
}

.responsive-row {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: center;
  /* PC 端间距 */
  gap: 30px 60px;
  padding: 40px 0;
}

.feature-col {
  /* PC端：一行两个，减去 60px 的一半间距 */
  width: calc((100% - 60px) / 2) !important;
  flex: none !important; /* 禁用 View Design 默认的 flex: 0 0 50% */
  max-width: none !important;
  margin-bottom: 40px;
}

.feature-card-content {
  display: flex;
  flex-direction: row;
  text-align: left;
  background: white;
  border: #BBBBBB solid 1px;
  align-items: center;
  padding: 23px 27px 21px 27px;
}

.feature-icon-first {
  width: 176px;
  height: 128px;
  margin-left: auto;
  margin-right: -20px;
}

.feature-icon {
  width: 128px;
  height: 128px;
  margin-left: auto;
}

.feature-card-content h3 {
  font-size: 26px;
  color: black;
}

.feature-card-content p {
  margin-top: 22px;
  color: #4F4F4F;
  font-size: 14px;
  margin-bottom: 45px;
}

.feature-card-content a {
  font-size: 18px;
  text-decoration: none;
  color: #4F4F4F;
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  .features {
    padding: 15px;
  }

  h2 {
    font-size: 16px;
    margin-bottom: 0px;
  }

  .feature-col {
    margin-bottom: 20px;
  }

  .feature-card-content {
    padding: 13px 17px 11px 17px;
  }

  .feature-icon-first {
    width: 46px;
    height: 38px;
    margin-right: -15px;
  }

  .feature-icon {
    width: 32px;
    height: 32px;
  }

  .feature-card-content h3 {
    font-size: 13px;
  }

  .feature-card-content p {
    margin-top: 12px;
    font-size: 12px;
    margin-bottom: 15px;
  }

  .feature-card-content a {
    font-size: 14px;
  }

  .feature-col {
    /* 移动端：一行两个，减去 12px 的一半 */
    width: calc((100% - 12px) / 2) !important;
  }

  .responsive-row {
    /* 移动端间距调小 */
    gap: 12px;
    padding: 20px 10px;
  }
}
</style>
